<template>
	<div class="indicator_blood_pressure">
		<div class="px-32">
			<IndicatorBase :list="labelBase" :record-date="lastRecord.measureTime" :status="lastRecord.status" />
			<div class="indicator_blood_content">
				<van-tabs v-model="dateType" color="#1F2329">
					<van-tab :name="1" title="日"></van-tab>
					<van-tab :name="2" title="周"></van-tab>
					<van-tab :name="3" title="月"></van-tab>
				</van-tabs>
				<indicatorReportTitle title="血糖趋势" :label="dateDesc" @labelSelect="selectTime" />
				<div class="chars_title mt-28"><div>血糖（mmol/L）</div><div class="tag tag_primart ">空腹</div></div>
				<IndicatorChart ref="chart1" container="chart1" class="mt-28 " />
				<div class="chars_title mt-28"><div>血糖（mmol/L）</div><div class="tag tag_blue ">餐后</div></div>
				<IndicatorChart ref="chart2" container="chart2" class="mt-28" />
				<div class="chars_title mt-28"><div>血糖（mmol/L）</div><div class="tag tag_warry ">随机</div></div>
				<IndicatorChart ref="chart3" container="chart3" class="mt-28" />
			</div>
		</div>

		<IndicatorTable
			class="mt-28"
			:loading.sync="loading"
			:list="list"
			:finished="true"
			@more="
                $router.push(
                    `/indicator/bloodSugar/list?previewType=${previewType}&patientId=${patientId}`
                )
            "
			@load="getList"
			@onUpdate="clickEdit"
		/>
		<foot-button v-if="previewType !== 'doctor'">
			<van-button type="primary" block @click="clickCreate">记录血糖</van-button>
		</foot-button>
		<van-popup v-model="showSelectDateTime" position="bottom" round>
			<van-datetime-picker
				v-model="currentDate"
				:type="datetimeType"
				title="选择日期"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="confirmTime"
				@cancel="showSelectDateTime = false"
			/>
		</van-popup>
		<van-popup v-model="showSelectWeek" round position="bottom">
			<van-picker
				show-toolbar
				ref="picker"
				:columns="columns"
				@cancel="showSelectWeek = false"
				@confirm="confirmTime"
				@change="onChange"
			>
				<template #option="option">
					<div class="week_picke_style" v-if="option.type === 'week'">
						<div class="title">
							{{ weekObj[option.number] }}
						</div>
						<div class="label">
							{{$moment(option.value).startOf('isoWeek').format('MM.DD')}}-{{
                                    $moment(option.value)
                                        .endOf('isoWeek')
                                        .format('MM.DD')
							}}
						</div>
					</div>
					<div v-else class="picke_style">
						{{ option.value }}
					</div>
				</template>
			</van-picker>
		</van-popup>
	</div>
</template>

<script>
import IndicatorBase from './components/indicator-base.vue'
import IndicatorChart from './components/indicator-chart.vue'
import IndicatorTable from './components/history-list.vue'
import indicatorReportTitle from './components/indicator-report-title.vue'
import MixinList from './mixins/list'
export default {
    name: 'indicatorBloodPressure',
    components: {
        IndicatorBase,
        IndicatorChart,
        IndicatorTable,
        indicatorReportTitle
    },
    mixins: [MixinList],
    data: () => ({
        labelBase: [],
        dateType: 1,
        editUrl: '/indicator/bloodSugar/edit',
    }),
    methods: {
        async load () {
            const lastInfo = await this.$api.indicator.bloodSugarLastInfo({
                patientId: this.patientId,
                date: this.$moment().format('YYYY-MM-DD')
            })
            if (!lastInfo.code) {
                const { bloodSugarInfo } = lastInfo.data
                this.handleLastRecord(bloodSugarInfo)
                this.getDetail()
            }
            await this.getList()
        },
        // 最近一次记录的逻辑处理
        handleLastRecord (record) {
            record ??= []
            if (record.measureTime)
                record.measureTime = this.$utils.substrLastIndex(record.measureTime, ':', true)
            else
                record.measureTime = '您还没有上传血糖记录'

            this.labelBase = [{
                value: record.bloodSugar,
                label: `${this.$status.bloodSugarType[record.sugarType] || '餐后'}`,
                unit: 'mmol/ L'
            }]

            record.status = this.$status.bloodStatus[record.bloodSugarStatus]

            this.lastRecord = record
        },
        // 处理 chart 数据
        getDetail () {
            let measureTime = this.$moment(this.sunData).format('YYYY-MM-DD 00:00:00')
            this.$api.indicator.getBloodsugarCharts({
                patientId: this.patientId,
                measureTime,
                dateType: this.dateType,
            }).then(({ code, data }) => {
                if (!code) {
                    // 格式化图表数据
                    let xAxis1 = []
                    let data1 = []
                    let xAxis2 = []
                    let data2 = []
                    let xAxis3 = []
                    let data3 = []
                    data && data.forEach(v => {
                        let time = this.$moment(v.measureTime).format(this.dateType === 1 ? 'HH:mm' : 'MM-DD')
                        if (v.sugarType === 1) {
                            xAxis1.push(time)
                            data1.push(v.bloodSugar)
                        }
                        if (v.sugarType === 2) {
                            xAxis2.push(time)
                            data2.push(v.bloodSugar)
                        }
                        if (v.sugarType === 3) {
                            xAxis3.push(time)
                            data3.push(v.bloodSugar)
                        }

                    })
                    let obj = {
                        markArea: {
                            itemStyle: {
                                color: 'rgba(31, 35, 41, 0.1)'
                            },
                            data: []
                        },
                    }
                    this.$nextTick(() => {
                        this.$refs.chart1.start({
                            ...obj,
                            datas: [
                                { name: '空腹', color: '#14c9c9', data: data1 }
                            ],
                            xAxis: xAxis1
                        })
                        this.$refs.chart2.start({
                            ...obj,
                            datas: [
                                { name: '餐后', color: '#5285f4', data: data2 }
                            ],
                            xAxis: xAxis2
                        })
                        this.$refs.chart3.start({
                            ...obj,
                            datas: [
                                { name: '随机', color: '#f7ba1e', data: data3 }
                            ],
                            xAxis: xAxis3
                        })

                    })
                }
            })
        },
        // 获取历史记录
        async getList () {
            this.loading = true
            const res = await this.$api.indicator.bloodSugarPage({
                patientId: this.patientId,
                page: this.page,
                limit: 5
            })
            this.loading = false
            if (!res.code) {
                let arr = res.data.list.map(v => ({
                    ...v,
                    list: [{
                        number: v.bloodSugar,
                        unit: 'mmol/L',
                        other: `${this.$status.bloodSugarType[v.sugarType] || '餐后'}`,
                        status: this.$status.bloodStatus[v.bloodSugarStatus],
                    }],
                    time: this.$moment(v.measureTime).format('HH:mm'),

                }))
                this.list = this.initList(this.list, arr)
                this.total = res.data.total
                this.page++
            }
        }
    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure {
	min-height: calc(100vh - 216px);
	padding: 40px 0;
	.history {
		.history_title {
			font-family: PingFangSC-Medium;
			font-size: 34px;
			font-weight: normal;
			line-height: 41px;
			color: #000000;
		}
	}
}
.indicator_blood_content {
	border-radius: 16px;
	background-color: #ffffff;
	overflow: hidden;
	margin-top: 28px;
	padding: 0 32px 40px 32px;
}
.picke_style {
	font-size: 40px;
	color: #14161a;
}
.week_picke_style {
	text-align: center;
	.title {
		font-size: 28px;
		color: #14161a;
	}
	.label {
		color: @gray-9;
		font-size: 22px;
	}
}
.chars_title {
	display: flex;
	font-size: 18px;
	color: #8f959e;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
	height: 44px;
	.tag {
		width: 76px;
		height: 44px;
		line-height: 44px;
		border-radius: 7px;
		color: #ffffff;
		text-align: center;
		font-size: 24px;
	}
	.tag_primart {
		background-color: #14c9c9;
	}
	.tag_blue {
		background-color: #5285f4;
	}
	.tag_warry {
		background-color: #f7ba1e;
	}
}
</style>
